const relations = [
    'contact', 'referralSource', 'milestone', 'type', 'type.outcomes', 'owner',
    'location', 'partExchanges', 'partExchanges.vehicle', 'pipeline', 'pipeline.milestones'
]

import { LeadResource, LeadSchema } from '../Api/Lead'

export default {
    namespaced: true,
    state: {
        current: null,
    },   
    mutations: {
        set(state, lead) {
            state.current = lead;
        },
        updateOwner(state, owner) {
            state.current.owner_id = owner.id
            state.current.owner = owner
        },
        updateContact(state, contact) {
            state.current.contact_id = contact.id
            state.current.contact = contact
        },
        updateTitle(state, title) {
            state.current.title = title
        },
        updateMilestone(state, milestone) {
            state.current.milestone = milestone
            state.current.milestone_id = milestone.id
        },
        updateConcern(state, concern) {
            state.current.concern = concern
            state.current.concern_id = concern.id
        },
        updateValue(state, value) {
            state.current.value = value
        },
        updateLocation(state, location) {
            state.current.location = location
            state.current.location_id = location.id
        },
        updateReferralSource(state, referralSource) {
            state.current.referral_source = referralSource
            state.current.referral_source_id = referralSource.id
        },
        setPartExchanges(state, partExchanges) {
            Vue.set(state.current, 'part_exchanges', partExchanges)
        }
    },
    actions: {
        load(context, id) {
            return new Promise((resolve, reject) => {
                LeadResource.find(id, { with: relations }).then(response => {
                    let lead = new LeadSchema(response.data);
                    context.commit('set', lead);
                    resolve();
                }, (e) => { handleApiError(e, reject) });
            });
        },
        reload(context) {
            return context.dispatch('load', context.state.current.id)
        },
        delete(context) {
            return new Promise((resolve, reject) => {
                let resource = LeadResource.destroy(
                    context.state.current.id
                );

                resource.then(response => {
                    context.commit('set', null);

                    resolve(response.data);
                }, (error) => {
                    handleApiError(error, reject);
                });
            });
        },
        storeOrUpdate(context, lead) {
            return new Promise((resolve, reject) => {
                let resource = LeadResource.storeOrUpdate(
                    lead.id, lead
                );

                resource.then(response => {
                    context.commit('set', lead);

                    resolve(response.data);
                }, (error) => {
                    handleApiError(error, reject);
                });
            });
        },
        save(context) {
            return context.dispatch(
                'storeOrUpdate', 
                context.state.current
            );
        }
    }
}